export const headerConfig = {
  resetPassword: {
    logo: 'https://i.ibb.co/z71dLKh/Ministry-New-Logo-JPEG.jpg',
    iconURL:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/email-new.png',
    title: 'Reset Password',
  },
};
